import axios from './axios'

class ToolRepository {
  size (data) {
    return axios.post(`/tools/size`, data).then((response) => {
      return response.data
    })
  }
}

export default new ToolRepository()



// WEBPACK FOOTER //
// ./src/data/tool.repository.js